var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding4Line = function SvgBuilding4Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.1 19.2h1.8V21H2.1v-1.8h1.8V3.9a.9.9 0 0 1 .9-.9h14.4a.9.9 0 0 1 .9.9zm-1.8 0V4.8H5.7v14.4zm-9.9-8.1h2.7v1.8H8.4zm0-3.6h2.7v1.8H8.4zm0 7.2h2.7v1.8H8.4zm4.5 0h2.7v1.8h-2.7zm0-3.6h2.7v1.8h-2.7zm0-3.6h2.7v1.8h-2.7z"
  })));
};
export default SvgBuilding4Line;